import { createFileRoute, redirect } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    console.log('[Index] Checking auth status...')
    // Espera o auth resolver
    const isAuthenticated = await context.auth.whenReady()
    console.log('[Index] isAuthenticated:', isAuthenticated)

    // Redireciona baseado no estado de autenticação
    if (isAuthenticated) {
      console.log('[Index] Redirecting to /home')
      throw redirect({ to: '/home' })
    } else {
      console.log('[Index] Redirecting to /login')
      throw redirect({ to: '/login' })
    }
  },
  // Componente de loading enquanto processa (caso beforeLoad demore)
  pendingComponent: () => (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  ),
  component: () => null, // Nunca renderiza, sempre redireciona
})
